import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const DebtConsolidationFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4955902' height='600' />
}

export default React.memo(DebtConsolidationFormBlock)
